<form [formGroup]="resetPasswordForm" class="login-container">
  <div class="header">Reset Password</div>
  <div class="subheader">
    In order to protect your account, your password should be at least 8 letters and contain at least one uppercase and
    a number
  </div>
  <mat-form-field class="w-100-1">
    <mat-label>Enter Verification Code</mat-label>
    <input formControlName="verificationCode" matInput required type="text" />
  </mat-form-field>
  <mat-form-field class="w-100-1">
    <mat-label>Password</mat-label>
    <input [type]="showNewPassword ? 'text' : 'password'" formControlName="newPassword" matInput required />
    <mat-icon (click)="showNewPassword = !showNewPassword" class="password-visibility" matSuffix>
      @if (showNewPassword) {
        <fa-icon [icon]="['fas', 'eye-slash']" class="dark-gray"></fa-icon>
      } @else {
        <fa-icon [icon]="['fas', 'eye']" class="dark-gray"></fa-icon>
      }
    </mat-icon>
  </mat-form-field>
  <mat-form-field class="w-100-1">
    <mat-label>Verify Password</mat-label>
    <input [type]="showVerifyPassword ? 'text' : 'password'" formControlName="verifyPassword" matInput required />
    <mat-icon (click)="showVerifyPassword = !showVerifyPassword" class="password-visibility" matSuffix>
      @if (showVerifyPassword) {
        <fa-icon [icon]="['fas', 'eye-slash']" class="dark-gray"></fa-icon>
      } @else {
        <fa-icon [icon]="['fas', 'eye']" class="dark-gray"></fa-icon>
      }
    </mat-icon>
  </mat-form-field>
  @if (errorMessage) {
    <div class="message">
      <div class="error">
        {{ errorMessage || 'No Error' }}
      </div>
    </div>
  }
  <div class="button-container">
    <button
      (click)="resetPassword()"
      [disabled]="!resetPasswordForm.valid"
      class="button"
      color="primary"
      mat-raised-button>
      Reset Password
    </button>
  </div>
</form>
